import { motion } from "framer-motion";

const easing = [0.16, 1, 0.3, 1];

export default function Reveal({
  children,
  delay = 0,
  y = 40,
  duration = 1.1,
  className = "",
  once = true,
}) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration, delay, ease: easing }}
    >
      {children}
    </motion.div>
  );
}
